/*import { cwColors, cwCategories, cwEngravingColors, cwSymbols } from './cwColors-2.js';*/

(function () {
    "use strict";
    function CWDESIGNSTUDIO() {
        const config = window.cwDesignStudioConfig || {};
        const cwDS = {
            productRoot: config.productRoot || '',
            productSEName: config.productSEName || '',
            productPartsVersion: config.partsVersion || '',
            dsVersion: 4,
            productName: config.productName || '',
            cwWindow: window,
            maxProductSize: config.maxSize || 2560,
            brainstormCap: 3,
            imageFormat: (config.partsVersion || '').includes("-webp") ? "webp" : "png",
            hasProductImages: config.hasProductImages || false,
            storeName: config.storeName || '',
            shopifyCdnBase: config.shopifyCdnBase || '',
            uploadLambdaUrl: config.uploadLambdaUrl || '',
            fallbackCartImage: config.fallbackCartImage || '',
        };
        const canvasImageType = { image: 'image', engraving: 'engraving' };
        const engravingImages = {};
        const cartImages = {};

        this.engravingImages = engravingImages;
        this.cartImages = cartImages;
        this.canvasImageType = canvasImageType;

        let currentRenderController = null;
        let dsEventController = null;

        let engTimer;
        let studio;
        let dsInitializing = true;

        this.initMutationObserver = function () {
            // Function to handle mutations
            const mutationHandler = (mutationsList, observer, callback) => {
                if (dsInitializing) return;
                for (let mutation of mutationsList) {
                    if (mutation.type === 'childList') {
                        callback();
                    }
                }
            };

            // Observer for .product__info-container
            const productInfoObserver = new MutationObserver((mutationsList, observer) => {
                mutationHandler(mutationsList, observer, updateProductPriceSub);
            });

            const productInfoElement = document.querySelector(".product__info-container");
            if (productInfoElement) {
                productInfoObserver.observe(productInfoElement, { childList: true, subtree: true });
            }

            // Observer for .js-kit-summary
            const kitSummaryObserver = new MutationObserver((mutationsList, observer) => {
                mutationHandler(mutationsList, observer, updateProductPriceSub2);
            });

            const kitSummaryElement = document.querySelector(".js-kit-summary");
            if (kitSummaryElement) {
                kitSummaryObserver.observe(kitSummaryElement, { childList: true, subtree: true });
            }

            // Observer for .bcpo input[type='checkbox']
            const bcpoObserver = new MutationObserver((mutationsList, observer) => {
                for (let mutation of mutationsList) {
                    if (mutation.type === 'childList') {
                        if (document.querySelector(".bcpo input[type='checkbox']") !== null) {
                            let bcpoEl = document.querySelector(".bcpo");
                            if (bcpoEl) {
                                bcpoEl.addEventListener("change", function (e) {
                                    if (e.target.matches("input")) {
                                        updateProductPrice();
                                    }
                                });
                            }
                            observer.disconnect();
                        }
                    }
                }
            });

            bcpoObserver.observe(document.body, { childList: true, subtree: true });

        };

        function debounce(func, wait) {
            let timeout;
            return function (...args) {
                const context = this;
                clearTimeout(timeout);
                timeout = setTimeout(() => func.apply(context, args), wait);
            };
        }

        function capitalizeWords(string) {
            return string.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
        }


        function getRequestValue(name) {
            if (name = (new RegExp('[?&]' + encodeURIComponent(name) + '=([^&]*)')).exec(location.search))
                return decodeURIComponent(name[1]);
        }

        function paletteScroll() {
            let partPanel = document.querySelector(".palette > ul");
            let studioPanel = document.querySelector(".studio > ul");
            let partsScrollLeft = partPanel.scrollLeft;
            let partsWidth = partPanel.offsetWidth;
            let studioScrollLeft = studioPanel.scrollLeft;
            let studioWidth = studioPanel.offsetWidth;
            let curAngle = Math.round(studioScrollLeft / studioWidth) + 1;
            let partItems = partPanel.querySelectorAll(":scope > li");
            let angleNeeded = parseInt(partItems[Math.round(partsScrollLeft / partsWidth)]?.getAttribute("data-angle"));

            if (curAngle !== angleNeeded) {
                studioPanel.classList.toggle("scrollMode");
                studioPanel.scrollTo({ left: parseInt((angleNeeded - 1) * studioWidth, 10), behavior: 'smooth' });
                studioPanel.addEventListener("scrollend", function handler() {
                    studioPanel.classList.toggle("scrollMode");
                    studioPanel.removeEventListener("scrollend", handler);
                });
            }
        }

        function showPalettePart(partName, animate) {
            let partPanel = document.querySelector(".palette > ul");
            let partsWidth = partPanel.offsetWidth;
            let targetPart = partPanel.querySelector(`.part-${partName}`);
            let partIndex = targetPart ? Array.from(partPanel.children).indexOf(targetPart) : 0;
            let targetScroll = partIndex * partsWidth;

            partPanel.classList.toggle("scrollMode");
            if (animate) {
                partPanel.scrollTo({ left: targetScroll, behavior: 'smooth' });
                partPanel.addEventListener("scrollend", function handler() {
                    partPanel.classList.toggle("scrollMode");
                    partPanel.removeEventListener("scrollend", handler);
                });
            } else {
                partPanel.scrollLeft = targetScroll;
                partPanel.classList.toggle("scrollMode");
            }
        }

        function buildPalette() {
            if (!config.parts || config.parts.length === 0) return;
            let paletteUl = document.querySelector(".palette > ul");
            if (!paletteUl) return;

            config.parts.forEach(function (part) {
                if (part.type === "included") return;

                let li = document.createElement("li");
                let h4 = document.createElement("h4");
                let divIcon = document.createElement("div");
                let spanPartName = document.createElement("span");
                spanPartName.className = "partName";
                let spanColorName = document.createElement("span");
                spanColorName.className = "colorName";
                let spanPrice = document.createElement("span");
                spanPrice.className = "productPartPrice";
                spanPrice.textContent = "$0";
                let spanRemove = document.createElement("span");
                spanRemove.className = "removePartText";
                spanRemove.innerHTML = '<i class="fas fa-trash-alt"></i>';

                h4.appendChild(divIcon);
                h4.appendChild(spanPartName);
                h4.appendChild(spanColorName);
                h4.appendChild(spanPrice);
                h4.appendChild(spanRemove);

                if (part.type === "model") {
                    li.className = "part-variant";
                    li.setAttribute("data-angle", part.angle);
                    h4.setAttribute("data-sename", "variant");
                    li.appendChild(h4);

                    let partOptions = document.createElement("div");
                    partOptions.className = "part-options";
                    let catSection = document.createElement("section");
                    catSection.className = "cat-variant";
                    let catUl = document.createElement("ul");
                    catUl.className = "cat-variant";

                    if (part.colors) {
                        part.colors.forEach(function (color) {
                            let sename = color.sename;
                            let fullSename = color.name.replace(/ /g, '-').toLowerCase();
                            let gcClass = color.name.includes("$") ? " isGCPrice" : "";
                            let swatchLi = document.createElement("li");
                            swatchLi.className = "variantSwatch variant-" + sename + gcClass;
                            swatchLi.title = color.name;
                            swatchLi.setAttribute("data-variant-id", "1484");
                            swatchLi.setAttribute("data-variant-sename", fullSename);
                            swatchLi.setAttribute("data-variant-discount", "");
                            let img = document.createElement("img");
                            img.id = "variant-swatch-" + sename;
                            img.width = 1000;
                            img.height = 600;
                            swatchLi.appendChild(img);
                            swatchLi.appendChild(document.createTextNode(color.name));
                            catUl.appendChild(swatchLi);
                        });
                    }

                    catSection.appendChild(catUl);
                    partOptions.appendChild(catSection);
                    li.appendChild(partOptions);
                } else {
                    li.className = "part-" + part.sename;
                    li.setAttribute("data-angle", part.angle);
                    h4.setAttribute("data-sename", part.sename);
                    li.appendChild(h4);
                    let partOptions = document.createElement("div");
                    partOptions.className = "part-options";
                    li.appendChild(partOptions);
                }

                paletteUl.appendChild(li);
            });
        }

        function buildBuySection() {
            let buySection = document.querySelector("section.buy");
            if (!buySection) return;
            let stickyBtn = buySection.querySelector(".stickyAddToCart");
            if (!stickyBtn) return;

            // Price data attributes
            buySection.setAttribute("data-price", config.compareAtPrice || 0);
            buySection.setAttribute("data-sale-price", config.price || 0);

            // Display price
            let bfPrice = buySection.querySelector(".bfPrice");
            if (bfPrice) bfPrice.textContent = "$" + Math.round(config.price / 100);

            // Lead time
            let shipTime = buySection.querySelector(".bfShippingTime");
            if (shipTime) shipTime.textContent = "Ships in " + (config.leadTime || '');

            // Inventory sold out — only add the element if actually sold out
            if (config.inventoryPolicy === 'deny' && config.inventoryQuantity <= 0) {
                let soldOutDiv = document.createElement("div");
                soldOutDiv.className = "inventorySoldOutWarning";
                soldOutDiv.textContent = "Out of Stock";
                stickyBtn.insertBefore(soldOutDiv, stickyBtn.firstChild);
            }

            // Sale badge — only add if there's a sale
            if (config.compareAtPrice > 0) {
                let saleDiv = buySection.querySelector(".salePrice");
                let saleSpan = saleDiv ? saleDiv.querySelector("span") : null;
                if (saleDiv && saleSpan) {
                    let saleAmount = Math.round((config.compareAtPrice - config.price) / 100);
                    saleSpan.textContent = "$" + saleAmount + " off";
                    saleDiv.style.display = '';
                }
            }
        }

        function loadPartMap() {
            document.querySelectorAll(".dsPartMap").forEach(function (mapEl) {
                let svgSRC = mapEl.dataset.src;
                let animate = true;
                fetch(svgSRC)
                    .then(function (r) { return r.ok ? r.text() : Promise.reject(); })
                    .then(function (html) {
                        mapEl.innerHTML = html;
                        mapEl.querySelectorAll("svg path").forEach(function (path) {
                            path.addEventListener("click", function () {
                                document.getElementById("cwDesignStudio").classList.remove("allPartsMode");
                                let partName = this.dataset.name;
                                if (partName === undefined) {
                                    partName = this.id;
                                }
                                showPalettePart(partName, animate);
                            });
                        });
                    })
                    .catch(function () { mapEl.innerHTML = ""; });
            });
        }

        function updateDesignURL() {
            const state = {
                baseModel: '', // We'll set this from cwColors
                colors: {},
                engravings: {}
            };
            // Get base model from VariantSEName and cwColors
            const variantSENameEl = document.getElementById('VariantSEName');
            const variantSEName = variantSENameEl ? variantSENameEl.value : '';
            if (variantSEName && cwColors[variantSEName]) {
                state.baseModel = cwColors[variantSEName].partnumber;
            }
            // Collect color selections
            document.querySelectorAll('.js-kit-group').forEach(function (group) {
                const partSEName = group.getAttribute('data-part-sename');
                const select = group.querySelector('.partColorOptions');
                if (select) {
                    const selectedOption = select.querySelector('option:checked');
                    if (selectedOption && selectedOption.getAttribute('data-sename')) {
                        state.colors[partSEName] = selectedOption.getAttribute('data-sename');
                    }
                }
            });
            // Collect engraving data
            document.querySelectorAll('.engraving-option').forEach(function (engOpt) {
                const groupName = engOpt.getAttribute('data-part-sename');
                const engravingData = {};

                engOpt.querySelectorAll('textarea').forEach(function (ta) {
                    const fieldName = ta.getAttribute('data-self-sename');
                    const value = ta.value;
                    if (fieldName && !fieldName.startsWith('imageangle') && value) {
                        engravingData[fieldName] = value;
                    }
                });

                if (Object.keys(engravingData).length > 0) {
                    state.engravings[groupName] = engravingData;
                }
            });
            // Update URL without reloading page
            const encodedState = btoa(encodeURIComponent(JSON.stringify(state)));
            const url = new URL(window.location.href);
            url.searchParams.set('design', encodedState);
            window.history.replaceState({}, '', url.toString());
        }

        function loadDesignFromURL() {
            const designParam = getRequestValue('design');
            if (!designParam) {
                // If no design parameter, create initial URL state
                updateDesignURL();
                return;
            }
            try {
                const state = JSON.parse(decodeURIComponent(atob(designParam)));
                // Apply base model if it exists
                if (state.baseModel) {
                    // Find the variant SEName by partnumber
                    for (const [seName, data] of Object.entries(cwColors)) {
                        if (data.partnumber === state.baseModel) {
                            const varEl = document.getElementById('VariantSEName');
                            if (varEl) {
                                varEl.value = seName;
                                varEl.dispatchEvent(new Event('change', { bubbles: true }));
                            }
                            // Update model-partnumber
                            const modelPN = document.getElementById('model-partnumber');
                            if (modelPN) {
                                const basePartNumber = modelPN.getAttribute('data-basepartnumber');
                                const newPartNumber = basePartNumber.replace('[]', state.baseModel);
                                modelPN.value = newPartNumber;
                            }
                            break;
                        }
                    }
                }

                // Apply colors
                for (const [partSEName, colorSEName] of Object.entries(state.colors)) {
                    const select = document.querySelector(`.js-kit-group[data-part-sename="${partSEName}"] .partColorOptions`);
                    if (select) {
                        const option = select.querySelector(`option[data-sename="${colorSEName}"]`);
                        if (option) {
                            select.value = option.value;
                            select.dispatchEvent(new Event('change', { bubbles: true }));
                        }
                    }
                }

                // Apply engravings
                for (const [groupName, engravingData] of Object.entries(state.engravings)) {
                    for (const [fieldName, value] of Object.entries(engravingData)) {
                        const ta = document.querySelector(`.engraving-option[data-part-sename="${groupName}"] textarea[data-self-sename="${fieldName}"]`);
                        if (ta) {
                            ta.value = value;
                            ta.dispatchEvent(new Event('input', { bubbles: true }));
                        }
                    }
                }
                updateDesignURL();

            } catch (error) {
                console.error('Error loading design state:', error);
            }
        }

        function fixDSImgSize(imgSrc, newSize) {
            let newImgSize, windowWidth = window.innerWidth;

            if (newSize === 0) {
                newImgSize = 2560;
                if (windowWidth < 2010) { newImgSize = 2000; }
                if (windowWidth < 1010) { newImgSize = 1000; }
                if (windowWidth < 650) { newImgSize = 640; }
                if (windowWidth < 510) { newImgSize = 500; }
                if (windowWidth < 330) { newImgSize = 320; }
                if (windowWidth < 110) { newImgSize = 100; }
                if (window.devicePixelRatio > 1.5) {
                    if (newImgSize === 2000) { newImgSize = 2560; }
                    if (newImgSize === 1000) { newImgSize = 2000; }
                    if (newImgSize === 640) { newImgSize = 1000; }
                    if (newImgSize === 500) { newImgSize = 1000; }
                    if (newImgSize === 320) { newImgSize = 640; }
                    if (newImgSize === 100) { newImgSize = 320; }
                }

                if (cwDS.imageFormat === 'webp') {
                    newImgSize = windowWidth >= 1010 ? 2560 : 1000;  // Use 2560 for desktop and 1000 for mobile
                }

            } else {
                newImgSize = newSize;
            }
            if (newImgSize > cwDS.maxProductSize) {
                newImgSize = cwDS.maxProductSize;
            }
            //newImgSize = 2000;
            if (typeof imgSrc === 'undefined') { return imgSrc; }
            imgSrc = imgSrc.replace("size-2560", "size-xxx").replace("size-2000", "size-xxx").replace("size-1000", "size-xxx").replace("size-320", "size-xxx");
            imgSrc = imgSrc.replace("size-500", "size-xxx").replace("size-640", "size-xxx").replace("size-100", "size-xxx").replace("size-xxx", `size-${newImgSize}`);
            return imgSrc;
        }

        function getLines(ctx, text, maxWidth) {
            let words = text.split(" "), lines = [], currentLine = words[0];
            for (let i = 1; i < words.length; i++) {
                let word = words[i], width = ctx.measureText(currentLine + " " + word).width;
                if (width < maxWidth) {
                    currentLine += " " + word;
                } else {
                    lines.push(currentLine);
                    currentLine = word;
                }
            }
            lines.push(currentLine);
            return lines;
        }

        function fillEngravingText(angle, engData, imageScale = 1.0) {
            let lines, imageAngle, groupName, xstart, ystart, maxWidth, fontSize, lineCount, textAlign, lineheight, engContext, engSmallContext, imagesizeW, imagesizeH, finalLines = [], imageSizeRatio;
            groupName = engData.group;

            if (cwEngravingColors[engData.textcolor] === undefined) { return false; }
            //remove emojis
            engData.text = engData.text.replace(/[\u{1F600}-\u{1F64F}\u{1F300}-\u{1F5FF}\u{1F680}-\u{1F6FF}\u{1F700}-\u{1F77F}\u{1F780}-\u{1F7FF}\u{1F800}-\u{1F8FF}\u{1F900}-\u{1F9FF}\u{1FA00}-\u{1FA6F}\u{1FA70}-\u{1FAFF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}\u{2300}-\u{23FF}\u{2B50}\u{1F004}\u{1F0CF}\u{1F18E}\u{1F191}-\u{1F251}\u{1F600}-\u{1F636}\u{1F645}-\u{1F64F}\u{1F300}-\u{1F641}\u{1F3E0}-\u{1F3F0}\u{25AA}\u{25AB}\u{25FE}\u{25FD}\u{25FB}\u{25FC}\u{2B1B}\u{2B1C}\u{25B6}\u{25C0}\u{1F200}-\u{1F251}\u{0F00}-\u{0FFF}\u{1D400}-\u{1D7FF}]/gu, '');

            lines = engData.text.split('\n');
            imagesizeW = Math.round(2560 * imageScale);;
            imagesizeW = parseInt(imagesizeW, 10);
            imageSizeRatio = imagesizeW / 2560;
            imagesizeH = imagesizeW * 0.6;

            const pdXstart = document.querySelector(`.partdata-xstart.part-${groupName}`);
            const pdYstart = document.querySelector(`.partdata-ystart.part-${groupName}`);
            const pdMaxwidth = document.querySelector(`.partdata-maxwidth.part-${groupName}`);
            const pdFontsize = document.querySelector(`.partdata-fontsize.part-${groupName}`);
            const pdLinecount = document.querySelector(`.partdata-linecount.part-${groupName}`);
            const pdImageAngle = document.querySelector(`.partdata-imageangle${angle}.part-${groupName}`);
            const pdTextalign = document.querySelector(`.partdata-textalign.part-${groupName}`);
            xstart = imagesizeW * parseFloat(pdXstart ? pdXstart.getAttribute("data-description") : 0, 10);
            ystart = imagesizeH * parseFloat(pdYstart ? pdYstart.getAttribute("data-description") : 0, 10);
            maxWidth = imagesizeH * parseFloat(pdMaxwidth ? pdMaxwidth.getAttribute("data-description") : 0, 10);
            fontSize = imagesizeH * parseFloat(pdFontsize ? pdFontsize.getAttribute("data-description") : 0, 10);
            lineCount = parseInt(pdLinecount ? pdLinecount.getAttribute("data-description") : 0, 10);
            imageAngle = pdImageAngle ? pdImageAngle.getAttribute("data-description") : "";
            textAlign = "center";
            if (pdTextalign && typeof pdTextalign.getAttribute("data-description") !== 'undefined') {
                textAlign = pdTextalign.getAttribute("data-description");
            }
            lineheight = fontSize * 1.3;
            engContext = document.createElement("canvas").getContext('2d');
            engContext.canvas.width = imagesizeW;
            engContext.canvas.height = imagesizeH;
            engContext.textBaseline = "middle";
            engContext.textAlign = textAlign;

            engContext.font = `300 ${fontSize}px 'Cabin', 'Font Awesome 6 Pro' `;
            engContext.fillStyle = cwEngravingColors[engData.textcolor].fontcolor;

            engSmallContext = document.createElement("canvas").getContext('2d');
            engSmallContext.canvas.width = maxWidth;
            engSmallContext.canvas.height = lineheight * lineCount;
            engSmallContext.textBaseline = "middle";
            engSmallContext.textAlign = textAlign;
            engSmallContext.font = `300 ${fontSize}px 'Cabin', 'Font Awesome 6 Pro' `;
            engSmallContext.fillStyle = "#000000";

            let smallContextX;
            if (textAlign === "right") {
                smallContextX = maxWidth;
            } else if (textAlign === "left") {
                smallContextX = 0;
            } else { // center
                smallContextX = maxWidth / 2;
            }

            //cwEngravingColors
            if (imageAngle !== "") {
                let imageAngleData, xScale, ySkew, xSkew, yScale, xMove, yMove;
                imageAngleData = imageAngle.split(",");
                xScale = imageAngleData[0];
                xSkew = imageAngleData[2];
                xMove = imageAngleData[4];
                yScale = imageAngleData[3];
                ySkew = imageAngleData[1];
                yMove = imageAngleData[5];

                let adjustRatio = null;
                // Try to find a matching adjust ratio textarea
                document.querySelectorAll(`.partdata-imageangleratio${angle}.part-${groupName}`).forEach(function (ratioEl) {
                    let val = parseFloat(ratioEl.getAttribute("data-description"));
                    if (!isNaN(val)) {
                        adjustRatio = parseFloat(val);
                    }
                });
                if (adjustRatio !== null) {
                    let renderedWidth = engContext.measureText(engData.text).width;
                    let textOffset = renderedWidth * adjustRatio;
                    xMove = (parseFloat(xMove) + textOffset) * imageSizeRatio;
                    yMove = (parseFloat(yMove) + (textOffset / -10)) * imageSizeRatio;
                } else {
                    xMove = xMove * imageSizeRatio;
                    yMove = yMove * imageSizeRatio;
                }
                engContext.setTransform(xScale, ySkew, xSkew, yScale, xMove, yMove);
            }

            for (let i = 0; i < lines.length; i++) { // Chat GTP optimization
                let tempLines = getLines(engContext, lines[i], maxWidth), extralines = 0;
                for (let j = 0; j < tempLines.length; j++) {
                    while (engContext.measureText(tempLines[j]).width > maxWidth) {
                        tempLines[j] = tempLines[j].substring(0, tempLines[j].length - 1);
                    }
                    if (finalLines.length < lineCount) {
                        engContext.fillText(tempLines[j], xstart, ystart + ((i + extralines) * lineheight));
                        engSmallContext.fillText(tempLines[j], smallContextX, (lineheight / 2) + ((i + extralines) * lineheight));
                        finalLines.push(tempLines[j]);
                    }
                    extralines++;
                }
            }

            const engTextArea = document.querySelector(`.engTextArea-${groupName}`);
            if (engTextArea) engTextArea.value = finalLines.join('\n');
            const engTextEl = document.getElementById(`engraving-text-${groupName}`);
            if (engTextEl) engTextEl.value = finalLines.join('\n');

            if (imageAngle === "hide") {
                engContext.clearRect(0, 0, engContext.canvas.width, engContext.canvas.height);
            } else if (imageAngle === "") {
                let imageDataURL = engSmallContext.canvas.toDataURL();
                let base64Image = imageDataURL.split(',')[1];
                engravingImages[`.partdata-imageangle${angle}`] = base64Image;
            }

            return engContext.canvas.toDataURL();
        }

        this.fillEngravingText = fillEngravingText;

        function createCanvasImage(dsImages, angle, imageToUpdate, imagesize) {
            let dsMainContext, tempImageCount, cwAngleImage, tempImages, dsBGContext;
            const isVariantSwatch = imageToUpdate.startsWith('variant-swatch-');

            if (currentRenderController) {
                currentRenderController.abort();
                //clearAllCanvasImages(); // Clear everything when aborting
            } else {
                // Also clear everything when starting a new render sequence
                //clearAllCanvasImages();
            }

            currentRenderController = new AbortController();
            const signal = currentRenderController.signal;

            dsMainContext = document.createElement("canvas").getContext('2d');
            //imagesize = "size-2560";
            tempImageCount = 0;
            cwAngleImage = document.getElementById(imageToUpdate);

            if (cwAngleImage !== null) {
                cwAngleImage.onload = function () {
                    if (imageToUpdate === 'dsAngle1Img') {
                        addBrainstorm(document.getElementById("dsAngle1Img"), "");
                    }
                };
            }
            tempImages = [];
            imagesize = fixDSImgSize("size-2560", imagesize).replace("size-", "");
            dsMainContext.canvas.width = parseInt(imagesize, 10);
            dsMainContext.canvas.height = (parseInt(imagesize, 10) * 0.6);
            dsMainContext.clearRect(0, 0, dsMainContext.canvas.width, dsMainContext.canvas.height);
            dsMainContext.fillStyle = "#FFF";

            let loadImagePromises = [];

            dsImages.forEach(function (imgItem) {
                if (imgItem.type === canvasImageType.image) {
                    loadImagePromises.push(new Promise(resolve => {
                        let tempImage = new Image();
                        tempImage.onload = () => resolve(tempImage);
                        tempImage.src = fixDSImgSize(imgItem.url, imagesize);
                        tempImage.crossOrigin = 'Anonymous';
                    }));
                } else if (imgItem.type === canvasImageType.engraving) {
                    loadImagePromises.push(new Promise(resolve => {
                        let engravingDataURL = fillEngravingText(angle, imgItem);
                        let tempImage = new Image();
                        tempImage.onload = () => resolve(tempImage);
                        tempImage.src = engravingDataURL;
                        tempImage.crossOrigin = 'Anonymous';
                    }));
                }
            });

            Promise.all(loadImagePromises).then(images => {
                dsMainContext.clearRect(0, 0, dsMainContext.canvas.width, dsMainContext.canvas.height);
                dsMainContext.fillStyle = "#FFFFFF";
                dsMainContext.fillRect(0, 0, dsMainContext.canvas.width, dsMainContext.canvas.height);

                images.forEach(image => {
                    dsMainContext.drawImage(image, 0, 0);
                });
                if (cwAngleImage !== null) {
                    cwAngleImage.src = dsMainContext.canvas.toDataURL("image/webp");
                    if (isVariantSwatch) {
                        let partOpts = cwAngleImage.closest('.part-options');
                        if (partOpts) partOpts.classList.add('swatches-loaded');
                    }
                }
                if (!isVariantSwatch) {
                    let tmpCanvas = document.createElement('canvas');
                    let tmpCtx = tmpCanvas.getContext('2d');
                    let targetWidth = 700;
                    let targetHeight = images[0].height * (targetWidth / images[0].width);

                    tmpCanvas.width = targetWidth;
                    tmpCanvas.height = targetHeight;

                    tmpCtx.fillStyle = "#FFFFFF";
                    tmpCtx.fillRect(0, 0, targetWidth, targetHeight);

                    images.forEach(image => {
                        tmpCtx.drawImage(image, 0, 0, targetWidth, targetHeight);
                    });

                    // Compress cart image
                    function getCompressedDataURL(canvas, quality) {
                        return canvas.toDataURL('image/jpeg', quality);
                    }

                    let quality = 1;
                    let resizedDataURL = getCompressedDataURL(tmpCanvas, quality);

                    while (resizedDataURL.length / 1024 > 95 && quality > 0.1) {
                        quality -= 0.1;
                        resizedDataURL = getCompressedDataURL(tmpCanvas, quality);
                    }

                    cartImages[`.cart-image-angle-${angle}`] = resizedDataURL;

                }
            }).catch(error => {
                if (error.message === 'Render aborted') {
                    console.log(`Render for angle ${angle} was aborted for newer render`);
                } else {
                    console.error('Error in canvas render:', error);
                }
            })
                .finally(() => {
                    // Clear controller reference if this is the current render
                    if (currentRenderController && currentRenderController.signal === signal) {
                        currentRenderController = null;
                    }
                });;
        }


        function drawDSImages(angle, imageToUpdate, variantID, imageSize) {
            let dsImages = [];
            dsImages.push({ type: canvasImageType.image, url: `${cwDS.productRoot}/parts${cwDS.productPartsVersion}/angle-${angle}/model/size-2560/bg.${cwDS.imageFormat}` });
            document.querySelectorAll(`.variantSwatch.variant-${variantID}`).forEach(function (swatch) {
                let variantSEName = swatch.getAttribute("data-variant-sename");
                if (variantSEName.indexOf("$") < 0) {
                    dsImages.push({ type: canvasImageType.image, url: `${cwDS.productRoot}/parts${cwDS.productPartsVersion}/angle-${angle}/model/size-2560/${variantSEName}.${cwDS.imageFormat}` });
                }
            });

            document.querySelectorAll(".js-kit-group").forEach(function (kitGroup) {
                kitGroup.querySelectorAll(".partColorOptions").forEach(function (selectEl) {
                    let groupName = selectEl.getAttribute("data-group-name");
                    let selected = selectEl.querySelector("option:checked");
                    if (selected) {
                        let colorName = selected.getAttribute("data-sename"), colorObj, ignoreColor, partColorLookup = colorName;
                        if (selected.getAttribute("data-finish") === "skin") { partColorLookup = `${colorName}-skin`; }
                        if (selected.getAttribute("data-finish") === "style") { partColorLookup = `${colorName}-style`; }
                        colorObj = cwColors[partColorLookup];
                        ignoreColor = (colorObj.offoption) ? true : false;
                        if (selected.getAttribute("data-finish") === "show") { ignoreColor = false }
                        if (!ignoreColor) {
                            dsImages.push({ type: canvasImageType.image, url: `${cwDS.productRoot}/parts${cwDS.productPartsVersion}/angle-${angle}/${groupName}/size-2560/${colorName}.${cwDS.imageFormat}` });
                        }
                    }
                });
                kitGroup.querySelectorAll(".textarea-group textarea").forEach(function (ta) {
                    let groupName = ta.getAttribute("data-group-name");
                    let selfName = ta.getAttribute("data-self-sename");
                    if (ta.value !== "" && selfName && !selfName.startsWith("imageangle")) {
                        dsImages.push({ type: canvasImageType.engraving, text: ta.value, group: groupName, textcolor: selfName });
                    }
                });
            });
            dsImages.push({ type: canvasImageType.image, url: `${cwDS.productRoot}/parts${cwDS.productPartsVersion}/angle-${angle}/model/size-2560/fg.${cwDS.imageFormat}` });
            createCanvasImage(dsImages, angle, imageToUpdate, imageSize);
        }

        function updatePartNumbers() {
            document.querySelectorAll(`.select.kit-group`).forEach(function (kitGroup) {
                let partSEName = kitGroup.getAttribute("data-part-sename"), partColorLookup;
                let selectEl = kitGroup.querySelector(`.partColorOptions`);
                let selected = selectEl ? selectEl.querySelector("option:checked") : null;
                if (selected) {
                    partColorLookup = selected.getAttribute("data-sename");
                    if (selected.getAttribute("data-finish") === "skin") { partColorLookup = `${partColorLookup}-skin` }
                    if (selected.getAttribute("data-finish") === "style") { partColorLookup = `${partColorLookup}-style` }
                    let pnEl = document.getElementById(`${partSEName}-partnumber`);
                    let partSelect = document.querySelector(`select.part-${partSEName}`);
                    if (pnEl && partSelect) {
                        pnEl.value = partSelect.getAttribute("data-part-number") + "-" + cwColors[partColorLookup].partnumber;
                    }
                }
            });

            const variantEl = document.getElementById('VariantSEName');
            if (variantEl) { //Shopify logic
                let curModel = variantEl.value;
                let curModelPartNumber = cwColors[curModel].partnumber;
                let modelPN = document.getElementById("model-partnumber");
                if (modelPN) {
                    let modelBasePartNumber = modelPN.getAttribute("data-basepartnumber"), fullPartNumber;
                    fullPartNumber = modelBasePartNumber.replace("[]", curModelPartNumber);
                    modelPN.value = fullPartNumber;
                }
            }
        }

        function drawAllDSImages() {


            if (currentRenderController) {
                currentRenderController.abort();
                //clearAllCanvasImages();
            }

            let anglesArray = [], imageToUpdate;
            document.querySelectorAll(".kit-group").forEach(function (kitGroup) {
                let groupAngle = kitGroup.getAttribute("data-angle");
                if (groupAngle !== null && groupAngle !== undefined && anglesArray.indexOf(groupAngle) === -1 && groupAngle !== "") {
                    anglesArray.push(groupAngle);
                }
            });

            if (anglesArray.length === 0) {
                anglesArray.push(1);
            }

            anglesArray.forEach(function (angleVal) {
                let variantID = 0;
                const variantEl = document.getElementById('VariantSEName');
                if (variantEl) {
                    variantID = variantEl.value;
                    variantID = variantID.replace("$", "");
                }

                imageToUpdate = `dsAngle${angleVal}Img`;
                drawDSImages(angleVal, imageToUpdate, variantID, 2560);
            });

            document.querySelectorAll(".variantSwatch").forEach(function (swatch) { //Shopify logic
                let variantSEName = swatch.getAttribute("data-variant-sename");
                variantSEName = variantSEName.replace("$", "");
                drawDSImages(1, `variant-swatch-${variantSEName}`, variantSEName, 1000);
            });
            updatePartNumbers();
        }

        function addBrainstorm(imgSrc, colors) {
            let bsUl = document.querySelector(".brainstorm ul");
            let bsLi = document.createElement("li");
            let bsImg = document.createElement("img");
            bsImg.src = imgSrc.src;

            bsImg.dataset.url = colors;
            bsLi.append(bsImg);
            bsLi.className = "mediaLoadDesign";

            if (imgSrc.src) {
                let currentLiCount = bsUl.querySelectorAll("li:not(.addDesign)").length;
                if (currentLiCount >= 4) {
                    let firstLi = bsUl.querySelector("li:not(.addDesign)");
                    if (firstLi) firstLi.remove();
                }
                bsUl.appendChild(bsLi);
            }
            // Click handling via event delegation in attachDSEvents
        }


        function updateSelectedColorsPalette() {
            let palette = document.querySelector(".palette"), partList = document.querySelectorAll(".kit-group"), urlToPushHistory, partsURL = "", partFilesUrl = "";

            const variantEl = document.getElementById('VariantSEName');
            if (variantEl) { //Shopify logic
                let selectedColor, partName = "Model", selectedColorSE, variantSEName, partSEName = "variant";
                variantSEName = variantEl.value;
                if (variantSEName !== undefined) {
                    variantSEName = variantSEName.replace("$", "");
                }
                const varSwatch = document.querySelector(`.variantSwatch.variant-${variantSEName}`);
                selectedColor = varSwatch ? varSwatch.title : '';
                selectedColorSE = varSwatch ? varSwatch.getAttribute("data-variant-sename") : undefined;
                if (selectedColorSE !== undefined) {
                    selectedColorSE = selectedColorSE.replace("$", "");
                }
                const pPartName = palette.querySelector(`.part-${partSEName} h4 .partName`);
                if (pPartName) pPartName.innerHTML = `${partName}: `;
                const pColorName = palette.querySelector(`.part-${partSEName} h4 .colorName`);
                if (pColorName) pColorName.innerHTML = selectedColor;
                const pDiv = palette.querySelector(`.part-${partSEName} h4 div`);
                if (pDiv) pDiv.className = ` colorSwatch color${selectedColorSE} `;
                palette.querySelectorAll(`.part-${partSEName} .part-options .variantSwatch`).forEach(el => el.classList.remove("isSelected"));
                const activeVarSwatch = palette.querySelector(`.part-${partSEName} .part-options .variant-${selectedColorSE}.variantSwatch`);
                if (activeVarSwatch) activeVarSwatch.classList.add("isSelected");
                let varRadioButton = document.querySelector(`input[name^="Style"][value="$${selectedColorSE}"]`);

                if (varRadioButton) {
                    varRadioButton.checked = true;

                    try {
                        let event = new Event('change', { bubbles: true });
                        varRadioButton.dispatchEvent(event);
                    } catch (error) {
                        console.error('Error dispatching change event or calling onVariantChange:', error);
                    }
                }


                if (partFilesUrl !== "") { partFilesUrl = `${partFilesUrl}*`; }
                if (selectedColorSE !== undefined) {
                    partFilesUrl = `${partFilesUrl}model/${selectedColorSE}`;
                }
            }
            partList.forEach(function (partEl) {
                let partSelect, partName, partSEName, partGroupId, partItemId, textAreas, partPrice = 0;
                partSelect = partEl.querySelector(".partColorOptions");
                partName = partEl.getAttribute("data-part-name");
                partSEName = partEl.getAttribute("data-part-sename");
                partGroupId = parseInt(partEl.getAttribute("data-group-id"));
                textAreas = partEl.querySelectorAll(".partTextOptions");

                let selected = partSelect ? partSelect.querySelector("option:checked") : null;
                if (selected) {
                    let selectedColor = selected.getAttribute("data-name"), selectedColorSE = selected.getAttribute("data-sename"), curlocation, colorObj, ignoreColor, partColorLookup = selectedColorSE, upchargeCheckbox;
                    const pPartName = palette.querySelector(`.part-${partSEName} h4 .partName`);
                    if (pPartName) pPartName.innerHTML = `${partName}: `;
                    const pColorName = palette.querySelector(`.part-${partSEName} h4 .colorName`);
                    if (pColorName) pColorName.innerHTML = selectedColor;
                    const pDiv = palette.querySelector(`.part-${partSEName} h4 div`);
                    if (pDiv) { pDiv.className = ` colorSwatch color${selectedColorSE} `; pDiv.innerHTML = ` `; }
                    palette.querySelectorAll(`.part-${partSEName} .part-options .colorSwatch`).forEach(el => el.classList.remove("isSelected"));
                    const activeSwatch = palette.querySelector(`.part-${partSEName} .part-options .color${selectedColorSE}.colorSwatch`);
                    if (activeSwatch) activeSwatch.classList.add("isSelected");
                    palette.querySelectorAll(`.part-${partSEName}`).forEach(el => el.classList.remove("offOptionSelected"));

                    if (selected.getAttribute("data-finish") === "skin") { partColorLookup = `${selectedColorSE}-skin` }
                    if (selected.getAttribute("data-finish") === "style") { partColorLookup = `${selectedColorSE}-style` }
                    colorObj = cwColors[partColorLookup];
                    ignoreColor = (colorObj.offoption) ? true : false;
                    upchargeCheckbox = document.querySelector('.js-upcharge-checkbox[data-part-name="' + partName + '"]');
                    if (upchargeCheckbox) {
                        if (!ignoreColor) {
                            partPrice = parseInt(upchargeCheckbox.value, 10);//.data("price");
                        }

                        if ((ignoreColor && upchargeCheckbox.checked) || (!ignoreColor && !upchargeCheckbox.checked)) {
                            upchargeCheckbox.click();
                        }


                    }
                    if (partPrice > 0) {
                        const pPrice = palette.querySelector(`.part-${partSEName} h4 .productPartPrice`);
                        if (pPrice) pPrice.innerHTML = `$${partPrice}`;
                    } else {
                        const pPrice = palette.querySelector(`.part-${partSEName} h4 .productPartPrice`);
                        if (pPrice) pPrice.innerHTML = ``;
                    }

                    if (selected.getAttribute("data-finish") === "show") { ignoreColor = false }
                    if (!ignoreColor) {
                        if (partFilesUrl !== "") { partFilesUrl = `${partFilesUrl}*`; }
                        partFilesUrl = `${partFilesUrl}${partSEName}/${selectedColorSE}`;
                        //curlocation
                    } else {
                        palette.querySelectorAll(`.part-${partSEName}`).forEach(el => el.classList.add("offOptionSelected"));
                    }
                }
                textAreas.forEach(function (textAreaEl) {
                    let selectedColor = "None", selectedColorSE = "none", objTextArea, textPriceDelta = 0, colorObj, partColorLookup, ignoreColor, upchargeCheckbox;
                    palette.querySelectorAll(`.part-${partSEName}`).forEach(el => el.classList.add("offOptionSelected"));
                    upchargeCheckbox = document.querySelector('.js-upcharge-checkbox[data-part-name="' + partName + '"]');
                    if (upchargeCheckbox && upchargeCheckbox.checked) {
                        upchargeCheckbox.click();
                    }
                    document.querySelectorAll(`.kit-text-area.part-${partSEName}`).forEach(function (ktaEl) {
                        if (ktaEl.value !== "" && !ktaEl.getAttribute("data-self-sename").toLowerCase().startsWith("imageangle")) {
                            selectedColor = ktaEl.getAttribute("data-self-name");
                            selectedColorSE = ktaEl.getAttribute("data-self-sename");
                            partColorLookup = selectedColorSE;
                            colorObj = cwColors[partColorLookup];
                            ignoreColor = (colorObj.offoption) ? true : false;

                            if (upchargeCheckbox) {
                                if ((ignoreColor && upchargeCheckbox.checked) || (!ignoreColor && !upchargeCheckbox.checked)) {
                                    upchargeCheckbox.click();
                                }
                                if (!ignoreColor) {
                                    textPriceDelta = parseInt(upchargeCheckbox.value, 10);//.data("price");
                                }
                            }
                            palette.querySelectorAll(`.part-${partSEName}`).forEach(el => el.classList.remove("offOptionSelected"));
                        }
                    });
                    const pPartName = palette.querySelector(`.part-${partSEName} h4 .partName`);
                    if (pPartName) pPartName.innerHTML = `${partName}: `;
                    const pColorName = palette.querySelector(`.part-${partSEName} h4 .colorName`);
                    if (pColorName) pColorName.innerHTML = selectedColor;
                    const pPrice = palette.querySelector(`.part-${partSEName} h4 .productPartPrice`);
                    if (pPrice) pPrice.innerHTML = `$${textPriceDelta}`;
                    const pDiv = palette.querySelector(`.part-${partSEName} h4 div`);
                    if (pDiv) pDiv.className = ` colorSwatch color${selectedColorSE} `;

                    toggleMustPaintMessage(partSEName);
                });

            });
            let requiredSKUs = [];
            document.querySelectorAll(`.kit-group`).forEach(function (kitGroup) {
                const isOptional = kitGroup.getAttribute('data-optional') === 'true';
                const skuNeeded = kitGroup.getAttribute('data-sku-needed');
                if (isOptional) {
                    // Check if there is a select list in this group
                    const selectList = kitGroup.querySelector('select');
                    if (selectList) {
                        // Get the selected option
                        const selectedOpt = selectList.querySelector('option:checked');
                        const selectedOptionSEName = selectedOpt ? selectedOpt.getAttribute('data-sename') : null;
                        const partName = kitGroup.getAttribute('data-part-name');
                        const selectedValue = selectList.value;
                        const colorObj = cwColors[selectedOptionSEName];
                        let isOffOption = false;
                        if (colorObj && colorObj.offoption === 'true') {
                            isOffOption = true;
                        }
                        if (!isOffOption && skuNeeded) {
                            requiredSKUs.push(skuNeeded);
                        }
                    }
                    // Handle text areas
                    const textAreasList = kitGroup.querySelectorAll('textarea[data-self-sename$="-text"]');
                    let nonEmptyTextAreaFound = false;
                    for (let i = 0; i < textAreasList.length; i++) {
                        if (textAreasList[i].value.trim() !== '') {
                            nonEmptyTextAreaFound = true;
                            break; // replaces jQuery's return false
                        }
                    }
                    if (nonEmptyTextAreaFound) {
                        requiredSKUs.push(skuNeeded);
                    }
                }
            });
            updateProductPrice();
        }

        function colorSwatchSelected() {
            let partSEName = this.parentElement.dataset.partsename;
            let selectEl = document.querySelector(`select.part-${partSEName}`);
            if (selectEl) {
                selectEl.value = this.dataset.value;
                selectEl.dispatchEvent(new Event("change", { bubbles: true }));
            }
            document.querySelectorAll(`textarea.paletteEngArea[data-parentsename='${partSEName}']`).forEach(function (ta) {
                debouncedUpdateTextAreas(ta);
            });
            updateSelectedColorsPalette();
        }

        function partTextChanged(textElement) {
            let parentPart, parentPartColor, colorObj, partName;
            partName = textElement.getAttribute("data-partsename");
            parentPart = textElement.getAttribute("data-parentsename");
            let parentSelect = document.querySelector(`.partColorOptions.part-${parentPart}`);
            let parentSelected = parentSelect ? parentSelect.querySelector("option:checked") : null;
            if (parentSelected) {
                parentPartColor = parentSelected.getAttribute("data-sename");
            }
            textElement.innerHTML = textElement.value;
            colorObj = cwColors[parentPartColor];
            if (textElement.value === '') {
                for (const prop in engravingImages) {
                    if (engravingImages.hasOwnProperty(prop)) {
                        delete engravingImages[prop];
                    }
                }
            }
            if (colorObj !== undefined) {
                document.querySelectorAll(`.part-${partName}`).forEach(el => { if (el.value !== undefined) el.value = ""; });
                let pdEl = document.querySelector(`.part-${partName}.partdata-${colorObj.engravingtext}`);
                if (pdEl) pdEl.value = textElement.value;
            }

            if (textElement.value === '' || !colorObj || colorObj.engravingtext === 'no-engraving') {


                let epEl = document.getElementById(`engraving-price-${partName}`);
                if (epEl) epEl.value = "";
                let etEl = document.getElementById(`engraving-text-${partName}`);
                if (etEl) etEl.value = "";
                let epnEl = document.getElementById(`engraving-part-number-${partName}`);
                if (epnEl) epnEl.value = "";
                let ecEl = document.getElementById(`engraving-color-${partName}`);
                if (ecEl) ecEl.value = "";

            } else {

                let generatedPartNumber;
                try {
                    // This can fail if color data is incomplete
                    let epnEl = document.getElementById(`engraving-part-number-${partName}`);
                    generatedPartNumber = `${epnEl ? epnEl.getAttribute("data-base-part-number") : ''}-${cwColors[colorObj.engravingtext].partnumber}`;
                } catch (error) {
                    // Log the actual error that's been causing the bug
                    if (typeof gtag !== 'undefined') {
                        gtag('event', 'engraving_generation_error', {
                            'event_category': 'design_studio_error',
                            'event_label': 'partnumber_generation_failed',
                            'error_message': error.message,
                            'part_name': partName,
                            'parent_color': parentPartColor,
                            'color_obj_exists': colorObj !== undefined,
                            'engraving_text_exists': colorObj?.engravingtext !== undefined
                        });
                    }
                    console.error('Failed to generate part number:', error);
                    return; // Exit early - don't update with bad data
                }


                try {
                    if (generatedPartNumber !== 'ENGRAVING-BLK' && generatedPartNumber !== 'ENGRAVING-WHI') {
                        if (typeof gtag !== 'undefined') {
                            gtag('event', 'engraving_partnumber_bug', {
                                'event_category': 'design_studio_error',
                                'event_label': 'incomplete_partnumber',
                                'part_name': partName,
                                'parent_part': parentPart,
                                'parent_color': parentPartColor || 'undefined',
                                'color_obj_exists': colorObj !== undefined,
                                'generated_partnumber': generatedPartNumber,
                                'non_interaction': true
                            });
                        }
                        console.warn('⚠️ Engraving bug detected:', {
                            partName: partName,
                            parentPartColor: parentPartColor,
                            colorObj: colorObj,
                            generatedPartNumber: generatedPartNumber
                        });
                    }
                } catch (error) {
                    // Log error in validation logic
                    if (typeof gtag !== 'undefined') {
                        gtag('event', 'engraving_validation_error', {
                            'event_category': 'design_studio_error',
                            'event_label': 'validation_exception',
                            'error_message': error.message,
                            'part_name': partName,
                            'non_interaction': true
                        });
                    }
                    console.error('Error in engraving validation:', error);
                }

                let epEl2 = document.getElementById(`engraving-price-${partName}`);
                let upchargeEl = document.getElementById(`${partName}-upcharge`);
                if (epEl2 && upchargeEl) epEl2.value = upchargeEl.value;
                let etEl2 = document.getElementById(`engraving-text-${partName}`);
                if (etEl2) etEl2.value = textElement.value;
                let epnEl2 = document.getElementById(`engraving-part-number-${partName}`);
                if (epnEl2) epnEl2.value = generatedPartNumber;
                let ecEl2 = document.getElementById(`engraving-color-${partName}`);
                if (ecEl2) ecEl2.value = colorObj.engravingtext;
            }
        }

        function toggleMustPaintMessage(partSEName) {
            let engTextEl = document.querySelector(`.palette .engTextArea-${partSEName}`);
            let parentSEName = engTextEl ? engTextEl.getAttribute("data-parentsename") : undefined, parentColor, textColor;
            if (parentSEName === undefined) { return false; }

            let parentSelect = document.querySelector(`.partColorOptions.part-${parentSEName}`);
            let parentSelected = parentSelect ? parentSelect.querySelector("option:checked") : null;
            if (parentSelected) {
                parentColor = parentSelected.getAttribute("data-sename");
            }

            textColor = cwColors[parentColor].engravingtext;
            if (textColor === "no-engraving") {
                document.querySelectorAll(`.palette .part-${partSEName}`).forEach(el => { el.classList.remove("disableEngraving", "allowEngraving"); el.classList.add("disableEngraving"); });
                document.querySelectorAll(`.part-${partSEName} textarea`).forEach(el => el.value = "");
            } else {
                document.querySelectorAll(`.palette .part-${partSEName}`).forEach(el => { el.classList.remove("disableEngraving", "allowEngraving"); el.classList.add("allowEngraving"); });
            }
        }

        function checkLastPartLogic() {
            let partPanel = document.querySelector(".palette > ul");
            if (!partPanel) return;
            let partsScrollLeft = partPanel.scrollLeft, partsWidth = partPanel.offsetWidth, rndCurScroll = 0, rndFullWidth = 0;
            let newScrollLeft = partsScrollLeft + (partsWidth), mainPalette = document.querySelector(".palette"), partPanelLength = document.querySelectorAll(".palette > ul > li").length;

            rndCurScroll = (Math.round(newScrollLeft / 20) + Math.round(partsWidth / 20)) * 20;
            rndFullWidth = Math.round((partsWidth * partPanelLength) / 20) * 20;

            if (rndCurScroll <= rndFullWidth) {
                mainPalette.classList.remove("onLastPart");
            } else {
                mainPalette.classList.add("onLastPart");
            }
        }

        function symbolSelected() {
            let partSEName, curText, engTextArea, startPos, endPos, newCursorPos;
            partSEName = this.parentElement.dataset.partsename;
            engTextArea = document.querySelector(`.engTextArea-${partSEName}`);
            if (!engTextArea) return;
            startPos = engTextArea.selectionStart;
            endPos = engTextArea.selectionEnd;
            curText = engTextArea.value;

            engTextArea.value = curText.substring(0, startPos) + this.dataset.code + curText.substring(endPos, curText.length);

            newCursorPos = startPos + this.dataset.code.length;
            engTextArea.selectionStart = newCursorPos;
            engTextArea.selectionEnd = newCursorPos;

            engTextArea.dispatchEvent(new Event("input", { bubbles: true }));
            debouncedUpdateTextAreas(engTextArea);
            engTextArea.focus();
        }

        function movePreviousPart() {
            let partPanel = document.querySelector(".palette > ul");
            let partsScrollLeft = partPanel.scrollLeft;
            let partsWidth = partPanel.offsetWidth;
            partPanel.classList.toggle("scrollMode");
            partPanel.scrollTo({ left: partsScrollLeft - partsWidth, behavior: 'smooth' });
            partPanel.addEventListener("scrollend", function handler() {
                partPanel.classList.toggle("scrollMode");
                partPanel.removeEventListener("scrollend", handler);
            });
        }

        function moveNextPart() {
            let mainPalette = document.querySelector(".palette");
            let partPanel = document.querySelector(".palette > ul");
            let partsScrollLeft = partPanel.scrollLeft;
            let partsWidth = partPanel.offsetWidth;
            let newScrollLeft = partsScrollLeft + partsWidth;

            if (mainPalette.classList.contains("onLastPart")) {
                toggleAllParts();
                return false;
            }

            partPanel.classList.toggle("scrollMode");
            partPanel.scrollTo({ left: newScrollLeft, behavior: 'smooth' });
            partPanel.addEventListener("scrollend", function handler() {
                partPanel.classList.toggle("scrollMode");
                partPanel.removeEventListener("scrollend", handler);
            });
        }

        function toggleAllParts() {
            document.getElementById("cwDesignStudio").classList.toggle("allPartsMode");
        }

        function updateProductPriceSub2() {
            updateProductPrice();
        }
        function updateProductPriceSub() {
            updateProductPrice();
        }
        function updateProductPrice() {
            let priceEl = document.querySelector("product-info .price__regular .price-item");
            if (priceEl && priceEl.innerHTML !== undefined) {
                let totalUpcharge = 0.0;
                let totalPriceText = priceEl.innerHTML.trim();
                let totalPrice = parseFloat(totalPriceText.replace(/[^\d.]/g, ''));
                document.querySelectorAll('.js-upcharge-checkbox:checked').forEach(function (cb) {
                    let partPrice = cb.value;
                    totalUpcharge += parseFloat(partPrice);
                });
                let upchargesEl = document.getElementById("product-up-charges");
                if (upchargesEl) upchargesEl.value = parseFloat(totalUpcharge);
                totalPrice += parseFloat(totalUpcharge);
                document.querySelectorAll(".bfPrice").forEach(el => el.innerHTML = "$" + totalPrice.toFixed(0));
            }
        };

        const debouncedUpdateTextAreas = debounce((textAreaChanged) => {
            partTextChanged(textAreaChanged);
            drawAllDSImages();
            updateSelectedColorsPalette();
        }, 150);

        function disablePaletteScroll() {
            let partPanel = document.querySelector(".palette > ul");
            if (partPanel) partPanel.classList.remove("scrollMode");
        }
        function enablePaletteScroll() {
            let partPanel = document.querySelector(".palette > ul");
            if (partPanel) partPanel.classList.add("scrollMode");
        }

        function applyGalleryColors() {
            let colorCode = this.querySelector("img")?.dataset.url;
            window.scrollTo({ top: 0, behavior: 'smooth' });
            //loadColorsFromCode(colorCode);
        }
        function selectPartHeading() {
            let headingParentSEName = this.getAttribute("data-sename"), animate = false;
            toggleAllParts();
            showPalettePart(headingParentSEName, animate);
        }

        function clearEngraving() {
            let engPartSEName = this.getAttribute("data-partsename"), engPartTextArea = document.querySelector(`.engTextArea-${engPartSEName}`);
            if (engPartTextArea) engPartTextArea.value = "";
            //engravingImages = {};
            for (const prop in engravingImages) {
                if (engravingImages.hasOwnProperty(prop)) {
                    delete engravingImages[prop];
                }
            }
            //updateTextAreas(engPartTextArea);
            debouncedUpdateTextAreas(engPartTextArea);
        }

        function removePart() {
            let parent = this.closest(".hasOffOption");
            if (parent) {
                let offOpt = parent.querySelector(".isOffOption");
                if (offOpt) offOpt.click();
                let engClear = parent.querySelector(".engClear");
                if (engClear) engClear.click();
            }
            return false;
        }

        function setCSSProperties() {

            let swatchSize, paletteColumns;
            if (window.matchMedia("(orientation: portrait)").matches) {
                swatchSize = getComputedStyle(document.documentElement).getPropertyValue('--colorswatchwidthPortrait').replace('px', '');
                document.documentElement.style.setProperty('--colorswatchwidth', `${swatchSize}px`);
                // you're in PORTRAIT mode
            } else {
                swatchSize = getComputedStyle(document.documentElement).getPropertyValue('--colorswatchwidthLandscape').replace('px', '');
                document.documentElement.style.setProperty('--colorswatchwidth', `${swatchSize}px`);
            }
            let partOptionsEl = document.querySelector(".part-options");
            paletteColumns = Math.floor(Math.floor((partOptionsEl ? partOptionsEl.offsetWidth : 0) / swatchSize) / 2) * 2;
            document.documentElement.style.setProperty('--column', paletteColumns);

            let trueVH = window.innerHeight * 0.01;
            document.documentElement.style.setProperty('--vh', `${trueVH}px`);

            let titleEl = document.querySelector(`.title h3`);
            let productTitleLength = titleEl ? titleEl.textContent.length : 0;
            document.documentElement.style.setProperty('--productTitleLength', `${productTitleLength}`);
        }
        function variantSelect() {
            const newVariantSEName = this.getAttribute("data-variant-sename");
            let varEl = document.getElementById('VariantSEName');
            if (varEl) varEl.value = newVariantSEName;

            let discount = this.getAttribute("data-variant-discount");
            if (discount) {
                let salePriceEl = document.querySelector(`.salePrice span`);
                if (salePriceEl) salePriceEl.innerHTML = `$${discount} off`;
            }

            drawAllDSImages();
            updateSelectedColorsPalette();
            updateDesignURL();
        }
        function addToCart() {

            try {
                document.querySelectorAll('[id^="engraving-part-number-"]').forEach(function (epnEl) {
                    let val = epnEl.value;
                    let siblingText = epnEl.parentElement ? epnEl.parentElement.querySelector('[id^="engraving-text-"]') : null;
                    let hasEngravingText = siblingText ? siblingText.value : '';

                    if (hasEngravingText && val === 'ENGRAVING') {
                        if (typeof gtag !== 'undefined') {
                            gtag('event', 'engraving_color_missing', {
                                'event_category': 'design_studio_error',
                                'event_label': 'addtocart_missing_color',
                                'element_id': epnEl.id,
                                'non_interaction': false
                            });
                        }
                        console.error('BUG: Engraving has text but no color suffix', epnEl.id);
                    }
                });
            } catch (e) {
                // Silently fail - don't block add to cart
                console.warn('Logging check failed:', e);
            }

            let stickyBtn = document.querySelector(".stickyAddToCart");
            if (stickyBtn && !stickyBtn.classList.contains("CheckoutClicked")) {
                if (document.querySelectorAll(".inventorySoldOutWarning").length === 0) {
                    stickyBtn.classList.add("CheckoutClicked");


                    for (const [key, value] of Object.entries(engravingImages)) {
                        let engEl = document.querySelector(`${key}`);
                        if (engEl) engEl.value = value;
                    }

                    let cartImageEl = document.getElementById('cartImage');
                    for (const [key, value] of Object.entries(cartImages)) {
                        if (key === ".cart-image-angle-1") {
                            if (cartImageEl) cartImageEl.value = value;
                        }
                    }

                    const triggerAddToCart = () => {
                        if (cartImageEl) cartImageEl.value = "";
                        // Re-assign Shopify's submitButton ref in case constructor lost it
                        let productForm = document.querySelector('product-form');
                        if (productForm && !productForm.submitButton) {
                            productForm.submitButton = productForm.querySelector('[type="submit"]');
                        }
                        let addBtn = document.querySelector(".js-add-to-cart-button");
                        if (addBtn) addBtn.click();
                        let submitBtn = document.querySelector(".product-form__submit");
                        if (submitBtn) submitBtn.click();
                    };
                    if (!cwDS.hasProductImages) { //skip this step for images with a product image

                        //const lambdaUrl = 'https://ecl2plowwqejrwhhhpw2tuo7zi0lmutv.lambda-url.us-east-1.on.aws/'; // Original Base URL
                        //const lambdaUrl = 'https://dh43w5v2ii7cciqd3limza3ax40xvjpv.lambda-url.us-east-1.on.aws/'; // PROD Alias URL
                        const lambdaUrl = cwDS.uploadLambdaUrl || 'https://dh43w5v2ii7cciqd3limza3ax40xvjpv.lambda-url.us-east-1.on.aws/';
                        const cdnBase = cwDS.shopifyCdnBase || 'https://cdn.shopify.com/s/files/1/0791/8367/5687/files/';
                        var imageBlob = cartImageEl ? cartImageEl.value : "";

                        fetch(lambdaUrl, {
                            method: 'POST',
                            body: JSON.stringify({ 
                                image: imageBlob,
                                storeName: cwDS.storeName || ''
                            }),
                            headers: {
                                'Content-Type': 'application/json'
                            }
                        })
                            .then(response => response.json())
                            .then(data => {
                                const imageUrl = data.cdnUrl || `${cdnBase}${data.uniqueFileName.replace(".jpeg", ".jpg")}`;
                                let cartImageFileEl = document.getElementById('cartImageFile');
                                if (cartImageFileEl) cartImageFileEl.value = imageUrl;
                                if (cartImageEl) cartImageEl.value = "";

                                triggerAddToCart();
                            })
                            .catch((error) => {
                                console.error('Error:', error);
                                let cartImageFileEl = document.getElementById('cartImageFile');
                                if (cartImageFileEl) cartImageFileEl.value = "";
                                triggerAddToCart();
                            });
                    } else {
                        triggerAddToCart();
                    }


                }
            }
        }

        function scrollHandler(e) {
            let atSnappingPoint = e.target.scrollLeft % e.target.offsetWidth === 0, timeOut = atSnappingPoint ? 0 : 150;
            clearTimeout(e.target.scrollTimeout);
            e.target.scrollTimeout = setTimeout(function () {
                paletteScroll();
                checkLastPartLogic();
            }, timeOut);
        }

        function brainstorm() {
            // Clear text selection
            if (window.getSelection) {
                if (window.getSelection().empty) {  // Chrome
                    window.getSelection().empty();
                } else if (window.getSelection().removeAllRanges) {  // Firefox
                    window.getSelection().removeAllRanges();
                }
            } else if (document.selection) {  // IE?
                document.selection.empty();
            }


            let partList = document.querySelectorAll(".kit-group:not([data-part-sename='hidden'])");
            let chosenColors = [];

            partList.forEach(function (kitGroup) {
                let selectEl = kitGroup.querySelector(".partColorOptions");
                var options = selectEl ? Array.from(selectEl.querySelectorAll('option')) : [];
                if (options.length > 0) {

                    // Select a random option
                    var selectedOption;
                    if (chosenColors.length < cwDS.brainstormCap) {

                        selectedOption = options[Math.floor(Math.random() * options.length)];
                        chosenColors.push(selectedOption.getAttribute('data-sename'));
                    } else {
                        // Select from chosen colors
                        var chosenColor = chosenColors[Math.floor(Math.random() * chosenColors.length)];
                        var matchingOptions = Array.from(selectEl.querySelectorAll(`option[data-sename="${chosenColor}"]`));

                        // If no options with the chosen color exist in this dropdown, select a random option from all options
                        if (matchingOptions.length === 0) {
                            selectedOption = options[Math.floor(Math.random() * options.length)];
                        } else {
                            selectedOption = matchingOptions[Math.floor(Math.random() * matchingOptions.length)];
                        }
                    }
                    if (selectEl) selectEl.value = selectedOption.value;
                }

            });
            drawAllDSImages();
            updateSelectedColorsPalette();
            updateDesignURL();

        }
        function brainstormMode() {
            document.getElementById("cwDesignStudio").classList.add("brainstormMode");

            // Test GA event tracking
            console.log('🧠 Brainstorm mode activated - sending GA event...');

            if (typeof gtag !== 'undefined') {
                gtag('event', 'brainstorm_mode_activated', {
                    'event_category': 'easter_egg',
                    'event_label': 'triple_click',
                    'non_interaction': true
                });
                console.log('✓ GA event sent');
            } else {
                console.log('✗ gtag not available');
            }
        }


        function tripleClick(callbackFunctionName) {
            var clicks = 0; // counter for clicks
            var delay = 500; // delay in milliseconds for detecting triple click
            return function () {
                clicks++;
                if (clicks === 1) {
                    setTimeout(function () {
                        if (clicks === 3) {
                            callbackFunctionName();
                        }
                        // Reset counter
                        clicks = 0;
                    }, delay);
                }
            };
        }

        function attachDSEvents() {
            if (dsEventController) dsEventController.abort();
            dsEventController = new AbortController();
            const signal = dsEventController.signal;

            // Title triple-click (brainstorm easter egg)
            document.querySelector("section.title")?.addEventListener("click", tripleClick(brainstormMode), { signal });

            // Brainstorm add button
            document.querySelector(".addDesign")?.addEventListener("click", brainstorm, { signal });

            // Color dropdowns → redraw + URL update
            document.querySelectorAll(".partColorOptions").forEach(function (el) {
                el.addEventListener("change", drawAllDSImages, { signal });
                el.addEventListener("change", function () { updateDesignURL(); }, { signal });
            });

            // Kit text areas → redraw + debounced URL update
            document.querySelectorAll(".kit-text-area").forEach(function (el) {
                el.addEventListener("input", drawAllDSImages, { signal });
                el.addEventListener("input", function () {
                    clearTimeout(window.urlUpdateTimer);
                    window.urlUpdateTimer = setTimeout(updateDesignURL, 500);
                }, { signal });
            });

            // Palette color swatches
            document.querySelectorAll(".part-options li").forEach(function (el) {
                el.addEventListener("click", colorSwatchSelected, { signal });
            });

            // Palette textareas → debounced text update
            document.querySelectorAll(".part-options textarea, .part-options .inTextarea").forEach(function (el) {
                el.addEventListener("input", function () { debouncedUpdateTextAreas(this); }, { signal });
            });

            // Textarea mousedown → disable palette scroll
            document.querySelectorAll(".part-options textarea").forEach(function (el) {
                el.addEventListener("mousedown", disablePaletteScroll, { signal });
            });
            document.addEventListener("mouseup", enablePaletteScroll, { signal });

            // Palette nav
            document.querySelector(".palette nav .previousPart")?.addEventListener("click", movePreviousPart, { signal });
            document.querySelector(".palette nav .allParts")?.addEventListener("click", toggleAllParts, { signal });
            document.querySelector(".palette nav .nextPart")?.addEventListener("click", moveNextPart, { signal });

            // Part headings
            document.querySelectorAll(".palette h4").forEach(function (el) {
                el.addEventListener("click", selectPartHeading, { signal });
            });

            // Variant swatches
            document.querySelectorAll(".palette .variantSwatch").forEach(function (el) {
                el.addEventListener("click", variantSelect, { signal });
            });

            // Symbol list
            document.querySelectorAll(".symbolList li").forEach(function (el) {
                el.addEventListener("click", symbolSelected, { signal });
            });

            // Upcharge checkboxes → price update
            document.querySelectorAll(".js-upcharge-checkbox").forEach(function (el) {
                el.addEventListener("change", updateProductPrice, { signal });
            });

            // Brainstorm gallery — event delegation on parent
            let bsUl = document.querySelector(".brainstorm ul");
            if (bsUl) {
                bsUl.addEventListener("click", function (e) {
                    let li = e.target.closest(".mediaLoadDesign");
                    if (li) applyGalleryColors.call(li, e);
                }, { signal });
            }

            // Clear engraving buttons
            document.querySelectorAll(".engClear").forEach(function (el) {
                el.addEventListener("click", clearEngraving, { signal });
            });

            // Remove part buttons
            document.querySelectorAll(".removePartText").forEach(function (el) {
                el.addEventListener("click", removePart, { signal });
            });

            // Add to cart
            document.querySelector(".stickyAddToCart")?.addEventListener("click", addToCart, { signal });

            // Scroll handler on both palette and studio for angle syncing
            // Palette scroll → paletteScroll() syncs studio angle (during navigation)
            // Studio scroll → paletteScroll() syncs after user swipe (mobile)
            let paletteUl = document.querySelector(".palette > ul");
            let studioUl = document.querySelector(".studio > ul");
            if (paletteUl) paletteUl.addEventListener("scroll", scrollHandler, { signal });
            if (studioUl) studioUl.addEventListener("scroll", scrollHandler, { signal });

            // Window resize/orientation
            window.addEventListener("orientationchange", setCSSProperties, { signal });
            window.addEventListener("resize", setCSSProperties, { signal });

            // Engraving "paint part" buttons (moved from createPalette)
            document.querySelectorAll(".engraving-paint-part").forEach(function (el) {
                el.addEventListener("click", function () {
                    showPalettePart(this.dataset.parent, true);
                }, { signal });
            });
        }

        function createPalette() {
            let partList = document.querySelectorAll(".kit-group:not([data-part-sename='hidden'])");
            updateSelectedColorsPalette();
            partList.forEach(function (partEl) {
                let partSelect = partEl.querySelector(".partColorOptions"), partName = partEl.getAttribute("data-part-name"), partSEName = partEl.getAttribute("data-part-sename"), colorArray = [], selectedColorSE;
                let ulColorList, sectionColorList, h5ColorList, colorCategoryNote, textAreas = partEl.querySelectorAll(".partTextOptions");
                document.querySelectorAll(`.part-${partSEName}`).forEach(el => el.classList.remove("hasOffOption"));
                let selectedOpt = partSelect ? partSelect.querySelector("option:checked") : null;
                if (selectedOpt) {
                    selectedColorSE = selectedOpt.getAttribute("data-sename");
                }
                if (partSelect) {
                    Array.from(partSelect.querySelectorAll("option")).forEach(function (optEl) {
                        let partColor = optEl.getAttribute("data-sename"), partColorLookup = partColor, optName = optEl.getAttribute("data-name"), colorObj, isSelectedColor;

                        if (optEl.getAttribute("data-finish") === "skin") { partColorLookup = `${partColor}-skin`; }
                        if (optEl.getAttribute("data-finish") === "style") { partColorLookup = `${partColor}-style`; }

                        colorObj = cwColors[partColorLookup];
                        isSelectedColor = selectedColorSE === partColor;
                        if (colorObj !== undefined) {
                            colorArray.push({
                                category: colorObj.category,
                                displayorder: colorObj.displayorder,
                                sename: partColor,
                                name: optName,
                                value: optEl.value,
                                selected: isSelectedColor,
                                offoption: colorObj.offoption
                            });
                        }
                    });
                }

                for (let i = 0; i < colorArray.length; i++) {
                    let liColor = document.createElement("li"), optionsClasses = "";
                    ulColorList = document.querySelector(`.part-${partSEName} .part-options ul.cat-${colorArray[i].category}`);

                    if (!ulColorList) {
                        sectionColorList = document.createElement("section");
                        sectionColorList.className = `cat-${colorArray[i].category}`;
                        sectionColorList.style.order = cwCategories[colorArray[i].category].displayorder;
                        colorCategoryNote = document.createElement("p");
                        colorCategoryNote.appendChild(document.createTextNode(cwCategories[colorArray[i].category].note));
                        h5ColorList = document.createElement("h5");
                        h5ColorList.appendChild(document.createTextNode(colorArray[i].category));
                        ulColorList = document.createElement("ul");
                        ulColorList.className = `cat-${colorArray[i].category}`;
                        ulColorList.dataset.partsename = partSEName;
                        sectionColorList.appendChild(h5ColorList);
                        sectionColorList.appendChild(ulColorList);
                        if (colorCategoryNote !== '') {
                            sectionColorList.appendChild(colorCategoryNote);
                        }
                        let partOptEl = document.querySelector(`.part-${partSEName} .part-options`);
                        if (partOptEl) partOptEl.appendChild(sectionColorList);
                    }

                    liColor.appendChild(document.createTextNode(colorArray[i].name));
                    if (colorArray[i].selected) {
                        optionsClasses = `isSelected ${optionsClasses}`;
                    }
                    if (colorArray[i].offoption === "true") {
                        optionsClasses = `isOffOption ${optionsClasses}`;
                        document.querySelectorAll(`.part-${partSEName}`).forEach(el => el.classList.add("hasOffOption"));
                        if (colorArray[i].selected) {
                            document.querySelectorAll(`.part-${partSEName}`).forEach(el => el.classList.add("offOptionSelected"));
                        }
                    }
                    liColor.className = `${optionsClasses} colorSwatch color${colorArray[i].sename}  ${colorArray[i].category}`;
                    liColor.title = colorArray[i].name;
                    liColor.dataset.value = colorArray[i].value;
                    liColor.style.order = colorArray[i].displayorder;
                    ulColorList.append(liColor);
                }

                textAreas.forEach(function (taEl) {
                    let parentPartName, partTextArea, liText, partTextClear, liTextClear, removeIcon, liSymbols, ulSymbols, pSymbols, detailsLink, sectionSymbols, divMustPaintMessage, divMustPaintMessageContent, pMustPaintNote, buttonMustPaint;

                    parentPartName = capitalizeWords(partSEName.replace("-engraving", '').replace("-", " "));
                    partTextArea = document.createElement("textarea");

                    partTextArea.dataset.partsename = partSEName;
                    partTextArea.dataset.parentsename = taEl.getAttribute("data-parentsename");

                    partTextArea.className = ` fa inTextarea paletteEngArea engTextArea-${partSEName}`;
                    partTextArea.placeholder = `Enter Custom Engraving Here`;
                    liText = document.createElement("li");

                    sectionColorList = document.createElement("section");
                    sectionColorList.className = "cat-text";

                    h5ColorList = document.createElement("h5");
                    h5ColorList.appendChild(document.createTextNode(`${partName} Text`));

                    ulColorList = document.createElement("ul");

                    sectionColorList.appendChild(h5ColorList);
                    liText.appendChild(partTextArea);

                    partTextClear = document.createElement("button");
                    liTextClear = document.createElement("li");

                    partTextClear.dataset.partsename = partSEName;
                    partTextClear.dataset.parentsename = taEl.getAttribute("data-parentsename");
                    partTextClear.className = "engClear";


                    removeIcon = document.createElement("i");
                    removeIcon.className = "fas fa-trash-alt";

                    //<i class="fas fa-trash-alt"></i>
                    partTextClear.appendChild(removeIcon);
                    partTextClear.appendChild(document.createTextNode(` Remove`));

                    liTextClear.appendChild(partTextClear);

                    //cwSymbols
                    sectionSymbols = document.createElement("section");
                    ulSymbols = document.createElement("ul");
                    ulSymbols.className = "symbolList";
                    ulSymbols.dataset.partsename = partSEName;
                    for (let symbol in cwSymbols) {
                        liSymbols = document.createElement("li");
                        //liSymbols.className = `fa${cwSymbols[symbol].mod} fa-${symbol} symbol${symbol}`;
                        liSymbols.className = `fa fa-${symbol} symbol${symbol}`;
                        liSymbols.dataset.code = cwSymbols[symbol].code;
                        liSymbols.style.order = cwSymbols[symbol].displayorder;
                        ulSymbols.appendChild(liSymbols);
                    }
                    sectionSymbols.appendChild(ulSymbols);
                    ulColorList.appendChild(liText);
                    ulColorList.appendChild(liTextClear);
                    sectionColorList.appendChild(ulColorList);
                    divMustPaintMessage = document.createElement("div");
                    divMustPaintMessage.className = "mustPaintMessage";
                    divMustPaintMessageContent = document.createElement("div");
                    divMustPaintMessageContent.className = "message-content";
                    pMustPaintNote = document.createElement("p");
                    pMustPaintNote.appendChild(document.createTextNode(`To add engraving, the ${parentPartName} must first be painted. Would you like to paint it now?`));
                    pSymbols = document.createElement("p");
                    pSymbols.className = "engraving-policy-message";
                    pSymbols.appendChild(document.createTextNode(`Engraved items are non-returnable.  `));
                    detailsLink = document.createElement("a");
                    detailsLink.href = "/support";
                    detailsLink.appendChild(document.createTextNode("Details"));
                    pSymbols.appendChild(document.createTextNode(`[`));
                    pSymbols.appendChild(detailsLink);
                    pSymbols.appendChild(document.createTextNode(`]`));
                    sectionSymbols.appendChild(pSymbols);
                    buttonMustPaint = document.createElement("button");
                    buttonMustPaint.className = "engraving-paint-part";
                    buttonMustPaint.dataset.parent = parentPartName.toLowerCase().replace(" ", "-");
                    buttonMustPaint.appendChild(document.createTextNode(` Paint ${parentPartName} `));
                    divMustPaintMessageContent.appendChild(pMustPaintNote);
                    divMustPaintMessageContent.appendChild(buttonMustPaint);
                    divMustPaintMessage.appendChild(divMustPaintMessageContent);

                    let partOptEl = document.querySelector(`.part-${partSEName} .part-options`);
                    if (partOptEl) {
                        partOptEl.appendChild(sectionColorList);
                        partOptEl.appendChild(sectionSymbols);
                        partOptEl.appendChild(divMustPaintMessage);
                    }
                    document.querySelectorAll(`.part-${partSEName}`).forEach(el => el.classList.add("hasOffOption"));
                    document.querySelectorAll(`.part-${partSEName}`).forEach(el => el.classList.add("offOptionSelected"));

                    // Engraving paint-part click binding handled in attachDSEvents
                });
            });
            setCSSProperties();
            attachDSEvents();
        }

        function createStudio() {
            let studioEl = document.querySelector(".studio"), angleArray = [], angleUL, angleLI, angleIMG, angleDIV, dsImageW = fixDSImgSize("size-2560", 0);
            let dsEl = document.getElementById("cwDesignStudio");
            document.querySelectorAll(".kit-group").forEach(function (kitGroup) {
                let angle = kitGroup.getAttribute("data-angle");
                if (angle) angleArray[angle - 1] = angle;
            });
            if (angleArray.length === 0) {
                if (document.querySelectorAll(".part-variant").length === 0) {
                    if (dsEl) dsEl.classList.add("dsHasNoParts");
                    document.documentElement.style.setProperty('--leftbgimage', `url(${cwDS.productRoot}/parts${cwDS.productPartsVersion}/angle-1/model/${dsImageW}/fg-left.${cwDS.imageFormat})`);
                    document.documentElement.style.setProperty('--rightbgimage', `url(${cwDS.productRoot}/parts${cwDS.productPartsVersion}/angle-1/model/${dsImageW}/fg-right.${cwDS.imageFormat})`);
                } else {
                    if (dsEl) dsEl.classList.add("dsHasOnePart");
                    document.documentElement.style.setProperty('--leftbgimage', `url(${cwDS.productRoot}/parts${cwDS.productPartsVersion}/angle-1/model/${dsImageW}/fg-left.${cwDS.imageFormat})`);
                    document.documentElement.style.setProperty('--rightbgimage', `url(${cwDS.productRoot}/parts${cwDS.productPartsVersion}/angle-1/model/${dsImageW}/fg-right.${cwDS.imageFormat})`);
                }
                angleArray[0] = 1;
            }


            angleUL = document.createElement("ul");
            angleUL.className = "scrollMode";
            for (let i = 0; i < angleArray.length; i++) {
                angleLI = document.createElement("li");
                angleLI.className = ` angle${angleArray[i]} `;
                angleIMG = document.createElement("img");
                angleIMG.id = `dsAngle${angleArray[i]}Img`;
                angleDIV = document.createElement("div");
                angleDIV.className = "dsPartMap";
                angleDIV.title = cwDS.productName;
                angleDIV.dataset.src = `${cwDS.productRoot}/parts${cwDS.productPartsVersion}/angle-${angleArray[i]}/part-map.svg`;
                angleLI.appendChild(angleIMG);
                angleLI.appendChild(angleDIV);
                angleUL.appendChild(angleLI);
            }
            if (studioEl) studioEl.appendChild(angleUL);
        }

        this.setupDesignStudio = function () {
            let ds = document.getElementById("cwDesignStudio");
            if (!ds) return;
            if (config.limitedEdition) ds.classList.add("isLimitedEdition");
            if (config.noParts) ds.classList.add("dsHasNoParts");
            if (config.maxSize) {
                ds.className = ds.className.replace(/maxProductWidth\d+/, '');
                ds.classList.add("maxProductWidth" + config.maxSize);
            }
            let titleH3 = document.querySelector("section.title h3");
            if (titleH3) titleH3.textContent = config.productName;
            buildBuySection();
            buildPalette();
            setCSSProperties();
            loadDesignFromURL();
            createPalette();
            createStudio();
            loadPartMap();
            drawAllDSImages();
            attachDSEvents();
            updateSelectedColorsPalette();
            updateProductPrice();
            dsInitializing = false;
            // Fallback: force-show swatch images if rendering is slow
            setTimeout(function () {
                document.querySelectorAll('.part-variant .part-options').forEach(function (el) {
                    el.classList.add('swatches-loaded');
                });
            }, 5000);
        };
        this.setupDesignStudio();
        if (document.getElementById("cwDesignStudio")) {
            this.initMutationObserver();
        }
    }
    window.addEventListener('load', function () {
        window.cwDesignStudio = new CWDESIGNSTUDIO();
    });


}());
